import { DateTime } from "luxon";

// local yyyy/MM/dd
const isoToFormatDate = (isoStr, format = "yyyy/MM/dd") => {
  try {
    return DateTime.fromISO(isoStr).setZone("utc+8").toFormat(format);
  } catch (err) {
    return null;
  }
};

const getDayStr = (dateStr) => {
  // get day of week in chinese
  try {
    const text = ["日", "一", "二", "三", "四", "五", "六"];
    const date = new Date(dateStr);
    return text[date.getDay()];
  } catch (err) {
    console.log(err.message);
    return null;
  }
};

const getTimeStr = (startTime, endTime) => {
  try {
    const startTimeStr = DateTime.fromISO(startTime).toFormat("HH:mm");
    let endTimeStr;
    if (endTime) {
      endTimeStr = DateTime.fromISO(endTime).toFormat("HH:mm");
    } else {
      endTimeStr = DateTime.fromISO(startTime)
        .plus({ minute: 30 })
        .toFormat("HH:mm");
    }
    return `${startTimeStr} - ${endTimeStr}`;
  } catch (err) {
    console.log(err.message);
    return null;
  }
};

const minToHour = (min) => Math.round((min / 60) * 10) / 10;

// today -> index 0, tomorrow -> index 1, ...
const getDayDiffIndex = (date) => {
  const todayMidnight = DateTime.local().startOf("day");
  const dayDiff = date.diff(todayMidnight, ["days"]).days;
  const index = Math.abs(Math.floor(dayDiff));

  return index;
};

// iso -> yyyy/MM/dd
const isoToInputDate = (isoStr) => {
  try {
    const str = DateTime.fromISO(isoStr)?.toFormat("yyyy-MM-dd");
    return str === "Invalid DateTime" ? "" : str;
  } catch (err) {
    return null;
  }
};

const inputDateToIso = (str) => {
  const date = DateTime.fromFormat(str, "yyyy-MM-dd");

  const dtUtc8 = date.setZone("Asia/Shanghai");

  const result = dtUtc8.toISO();

  return result === "Invalid DateTime" ? null : result;
};

const getRentDate = (startTimeISO, endTimeISO) => {
  if (startTimeISO && endTimeISO) {
    return `${isoToFormatDate(startTimeISO)} - ${isoToFormatDate(endTimeISO)}`;
  } else {
    return "";
  }
};

export {
  isoToFormatDate,
  getDayStr,
  getTimeStr,
  minToHour,
  getDayDiffIndex,
  isoToInputDate,
  inputDateToIso,
  getRentDate,
};
